import type { ReturnRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

interface UseAssignUserToReturnProps {
	onSuccess: (returnRequest: ReturnRequestDto) => void;
	onError?: (error: Error) => void;
}

export default function useAssignUserToReturn({
	onSuccess,
	onError,
}: UseAssignUserToReturnProps) {
	return useApiMutation(
		"post",
		"/shops/{shopId}/return-requests/{returnRequestId}/assigned-users",
		{
			notify: { success: false },
			onSuccess,
			onError: onError as ((error: unknown) => void) | undefined,
		},
	);
}
